import "./App.css";
import AupreaApp from "./AupreaApp";
import PublicRouter from "./PublicClient";
import PublicMission from "./PublicMission";
import { RejoindrePage } from "./Reseau";
import LienPerso from "./LienPerso";
import PublicConvention from "./PublicConvention";
import PublicCotisation from "./PublicCotisation";

function App() {
  // Routes publiques prioritaires (aucun login requis)
  if (typeof window !== "undefined") {
    const path = window.location.pathname;
    if (path.startsWith("/p/")) return <PublicRouter />;
    if (path.startsWith("/avis/") || path.startsWith("/suivi/")) return <PublicMission />;
    if (path.startsWith("/cotisation/")) return <PublicCotisation token={path.slice(12).split("/")[0]} />;
    if (path.startsWith("/convention/")) return <PublicConvention token={path.slice(12).split("/")[0]} />;
    if (path.startsWith("/r/")) return <LienPerso code={decodeURIComponent(path.slice(3).split("/")[0])} />;
    if (path.startsWith("/rejoindre/")) {
      const code = path.replace("/rejoindre/", "").split("/")[0].split("?")[0];
      return <RejoindrePage code={code} />;
    }
  }
  return <AupreaApp />;
}

export default App;
